define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const user = require('user');
    const storage = require('util/storage.util');
    const fetchUtil = require('util/fetch.util');
    const BaseView = require('common/base.view');

    module.exports = BaseView.extend({
        loadContent: function(articleId) {
            var deferred = $.Deferred();
            var url = '/webContent/' + user.get('lang') + '_' + articleId;
            storage.session.removeItem(url);

            if (!articleId) {
                return deferred.resolve('');
            }

            return fetchUtil.fetch({
                url: url,
                dataType: 'html'
            });
        },
    });
});
